/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The dates associated with an RdSAP report.
 */
export interface RdSAPAssessmentReportDates { 
    /**
     * When the report was assessed.
     */
    assessmentDate: string;
    /**
     * When the report was last edited. If null the report has never been edited.
     */
    readonly lastEditedDate?: string;
    /**
     * The date when the report was lodged with the register. If `null` then the report is not lodged. If this value is set then the `calculatedDate` must also be set.
     */
    readonly lodgementDate?: string;
    /**
     * When the report was last submitted to the engine for calculation. If `null` then the report has never been calculated.
     */
    readonly calculatedDate?: string;
    /**
     * When the report was marked as completed. If `null` then the report has is not completed.
     */
    readonly completedDate?: string;
    /**
     * When a request was sent to the register to cancel this report. If this is `null` then the report is not canceled. When set the `lodgementDate` will be set.
     */
    readonly canceledDate?: string;
    /**
     * This means the data is read-only.    Of the PDR not the EPC
     */
    finalisedDate?: string;
}

